<div class="d-flex justify-content-center">
  <div class="search-input white-input w-100">
    <mat-form-field appearance="outline">
      <input type="text" #searchInput [(ngModel)]="searchText" name="searchText" [placeholder]="placeholder" matInput (keyup.enter)="search()" />
      <mat-icon class="pointer align-self-center mr-2 pr-2 clear-button" *ngIf="searchText" (click)="searchText = ''; search()">clear</mat-icon>
      <mat-icon class="pointer" (click)="search()">search</mat-icon>
    </mat-form-field>
  </div>
</div>
